import React from "react";
import { Link } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";

// Redux
import { connect } from "react-redux";
import "./filters.css";
import PropTypes from "prop-types";
import {
  getFilterById,
  updateFilterGrouping,
  deleteFilterGroupingItems,
} from "../../../actions/filters";

import { ToastContainer, toast } from "react-toastify";

import Alert from "../../../components/alert/alert.component";
import { withRouter } from "../../../utils/withRouter";

class FilterGroupingUpdate extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      title: "",
      status: false,
      id: "",
    };
  }

  async componentDidMount() {
    const id = this.props.location.search.substr(4);
    const res = await this.props.getFilterById(id);

    this.setState({
      title: res.data.title,
      status: res.data.status,
      id: res.data._id,
    });
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  textToggler = () => {
    this.setState({
      status: !this.state.status,
    });
  };

  _submitHandler = async () => {
    const { title, status, id } = this.state;

    const dataToSend = { title, status, id };
    console.log(dataToSend);
    const res = await this.props.updateFilterGrouping(
      JSON.stringify(dataToSend)
    );
    console.log(res);

    this.setState({ loading: false });

    if (res) {
      this.setState({});
      toast(`${res.data.message}`, { containerId: "B" });
    } else {
      toast(`Some Error Occur`, { containerId: "B" });
    }
  };
  deleteAll = async () => {
    const { id } = this.state;
    const res = await this.props.deleteFilterGroupingItems(id);
    console.log(res);

    this.setState({ loading: false });

    if (res) {
      this.setState({});
      toast(`${res.data && res.data}`, { containerId: "B" });
    } else {
      toast(`Some Error Occur`, { containerId: "B" });
    }
  };

  render() {
    const { title, status } = this.state;

    TopBarProgress.config({
      barThickness: 4,
      barColors: {
        0: "rgb(51, 201, 45, .7)",
        ".3": "rgb(255, 77, 107, .7)",
        "1.0": "rgb(200, 125, 255, .7)",
      },
      shadowBlur: 5,
      shadowColor: "rgba(0, 0, 0, .5)",
    });

    return (
      <div className="container-scroller">
        {this.state.loading && <TopBarProgress />}

        <ToastContainer
        stacked 
          enableMultiContainer
          containerId={"B"}
          // position={toast.POSITION.TOP_RIGHT}
          position="top-right" // Hardcoded position
        />

        <div className="page-header">
          <h3 className="page-title"> Create Filter Grouping</h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/admin/products">Products</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Create Filter Grouping{" "}
              </li>
            </ol>
          </nav>
        </div>
        <div className="row">
          <div className="col-12 ">
            <Alert />
            <div className="container-fluid">
              <div className="row mb-3">
                <div className="col-md-3">
                  <p>Title</p>
                </div>
              </div>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control   "
                    id="title"
                    placeholder="Enter Title"
                    name="title"
                    value={title}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-md-3 ">
                  <div className="connection-all" onClick={this.textToggler}>
                    <span className={status ? "allcenter" : "allLeft "}>
                      ON
                    </span>

                    <span className={status ? "editRight" : "editcenter "}>
                      OFF
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt-5">
              <div className="row">
                <div className="col-md-2">
                  <button
                    type="button"
                    class="btn btn-success"
                    onClick={() => {
                      this._submitHandler();
                    }}
                  >
                    Update
                  </button>
                </div>
                <div className="col-md-6">
                  <button
                    type="button"
                    class="btn btn-danger"
                    onClick={() => {
                      this.deleteAll();
                    }}
                  >
                    Delete All items of this group
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

getFilterById.propTypes = {
  getFilterById: PropTypes.func.isRequired,
};

updateFilterGrouping.propTypes = {
  updateFilterGrouping: PropTypes.func.isRequired,
};
deleteFilterGroupingItems.propTypes = {
  deleteFilterGroupingItems: PropTypes.func.isRequired,
};
export default withRouter(connect(null, {
  getFilterById,
  updateFilterGrouping,
  deleteFilterGroupingItems,
})(FilterGroupingUpdate));
